module.exports = __webpack_public_path__ + "static/media/network.381f0bc6.svg";